import { ApiCall } from '@carto/meridian-ds/custom-icons'
import { styled } from '@mui/material'
import { showApiEndpointDialog } from '../../Dialogs'
import { Workflow, WorkflowListItem } from 'features/workflows/types'
import WorkflowFeatureBadge from './WorkflowFeatureBadge'
import { useApiEnabled } from 'features/workflows/utils/api'

interface Props {
  workflow: Workflow | WorkflowListItem
  compact?: boolean
  alert?: boolean
}

const ApiCallIcon = styled(ApiCall)(({ theme }) => ({
  width: theme.spacing(1.5)
}))

function WorkflowApiEnabled({ workflow, compact = false, alert = false }: Props) {
  return (
    <WorkflowFeatureBadge
      workflow={workflow}
      compact={compact}
      alert={alert}
      conditionCheck={useApiEnabled}
      icon={compact ? <ApiCall /> : <ApiCallIcon />}
      labelId="workflows.api.tagText"
      onClick={showApiEndpointDialog}
      zIndex={0}
    />
  )
}

export default WorkflowApiEnabled
